/** When your routing table is too long, you can split it into small modules **/
import Layout from "@/layout";

const shopsRouter = {
  path: "/other",
  component: Layout,
  hidden: true,
  redirect: "/other/message",
  meta: { title: "", icon: "el-icon-other", roles: ["admin"] },
  children: [
    {
      path: "message",
      component: () => import("@/pages/other/message"),
      name: "Message",
      meta: { title: "消息" },
    },
    {
      path: "mine",
      component: () => import("@/pages/other/mine"),
      name: "Mine",
      meta: { title: "个人中心" },
    },
    {
      path: "xieyi/:id",
      component: () => import("@/pages/other/xieyi"),
      name: "Xieyi",
      meta: { title: "协议" },
    },
    {
      path: "password",
      component: () => import("@/pages/other/password"),
      name: "Password",
      meta: { title: "修改密码" },
    },
    {
      path: "feedback",
      component: () => import("@/pages/other/feedback"),
      name: "feedback",
      meta: { title: "意见反馈" },
    }
  ],
};
export default shopsRouter;
